
import u from "umbrellajs"
import Google_Event from "app/tracking/google/event"

const track = () => {
  u("body").on("click", ".cell--listings--contact--button__link", () => {
    Google_Event.track({category: "Listings", action: "Contact"})
  })
}
export default {track}
